import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';
import URL from '@/creditflowresearch/Router/urlConstants';
import ExportToExcelButton from './ExportToExcelButton';

interface IProps {
  isVisible: boolean,
}

const BondsTileTools = ({ isVisible }: IProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Flex gap={ 10 } align="center">
      <ExportToExcelButton />
      <Button
        as="a"
        href={ URL.BONDS_INVENTORIES_ABS }
        target="_blank"
        variant="outline"
        size="S"
        fit={ { sm: 'full', md: 'full' } }
        dataTest="goToBondsLink"
      >
        All BWICS & Inventory
      </Button>
    </Flex>
  );
};

export default BondsTileTools;
